const CustomizeApi = (function(){
    return {
        "SendEmail": function (host, email, verify_type, send_type, language, handle_success, handle_error, property=undefined) {
            let url = host + "/account/api/v1/verify/code"
            let params;
            if (!property) {
                params = {
                    "verifyType": verify_type,
                    "sendType": send_type,
                    "sendParam": email,
                    "language": language
                }
            } else {
                params = {
                    "verifyType": verify_type,
                    "sendType": send_type,
                    "sendParam": email,
                    "language": language,
                    "property": property
                }
            }
            console.log(params);
            $.ajax({
                url: url,
                method: 'POST',
                xhrFields: {withCredentials: false},
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(params),
                success: function (data) {
                    console.log(data);
                    handle_success(data, email)
                },
                error: function (err) {
                    console.log(err);
                    handle_error(err)
                }
            })
        },
        "ChangePwd": function (host, client, email, new_password, verify_type, verify_code, handle_success, handle_error) {
            let url = host + "/account/api/v1/user/password/change"
            let params = {
                "clientId": client,
                "username": email,
                "newPassword": new_password,
                "verifyType": verify_type,
                "verifyCode": verify_code
            }
            console.log(params);
            $.ajax({
                url: url,
                method: 'POST',
                xhrFields: {withCredentials: false},
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(params),
                success: function (data) {
                    console.log(data);
                    handle_success(data)
                },
                error: function (err) {
                    handle_error(err)
                }
            })
        },
        "CheckUserExist": function (email, client, host, handle_success, handle_error) {
            let url = host + "/account/api/v1/user/exist"
            let params = {
                "username": email
            }
            $.ajax({
                url: url,
                method: 'POST',
                xhrFields: {withCredentials: false},
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(params),
                success: function (data) {
                    handle_success(data)
                },
                error: function (err) {
                    handle_error(err)
                }
            })
        },
        "BindExistAccount": function (host, email, access_token, region, verify_code, handle_success, handle_error) {
            let url = host + "/shopify/api/v1/bind"
            let params = {
                "bindType": 1,
                "region": region,
                "verifyCode": verify_code,
                "email": email
            }
            $.ajax({
                url: url,
                method: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                xhrFields: {withCredentials: false},
                data: JSON.stringify(params),
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", access_token)
                },
                success: function (data) {
                    handle_success(data)
                },
                error: function (err) {
                    handle_error(err)
                }
            })
        },
        "CreateAccount": function (host, email, access_token, region, handle_success, handle_error) {
            let url = host + "/shopify/api/v1/bind"
            let params = {
                "bindType": 2,
                "region": region,
                "email": email
            }
            $.ajax({
                url: url,
                method: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                xhrFields: {withCredentials: false},
                data: JSON.stringify(params),
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", access_token)
                },
                success: function (data) {
                    handle_success(data)
                },
                error: function (err) {
                    handle_error(err)
                }
            })
        },
        "Login": function (host, client_id, deviceInfo, username, password, handle_success, handle_error) {
            const login_url = host + "/account/api/v1/user/login"
            let params = { "username": username, "password": password, "clientId": client_id,
                "deviceInfo": deviceInfo, "grantType": "password"}
            $.ajax({
                url: login_url,
                method: 'post',
                xhrFields: {withCredentials: false},
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(params),
                success: function (data) {
                    handle_success(data)
                },
                error: function (err) {
                    console.log(err);
                    handle_error(err)
                }
            })
        },
        "GetShopifyBindInfo": function (host, token, handle_success, handle_error) {
            let request_url = host + "/shopify/api/v1/info"
            $.ajax({
                url: request_url,
                type: "POST",
                xhrFields: {withCredentials: false},
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", token)
                    request.setRequestHeader("Content-Type", "application/json")
                },
                success: function (data) {
                    handle_success(data)
                },
                error: function (err) {
                    console.log(err);
                    handle_error(err)
                }
            })
        },
        "MultipassLogin": function (multipass, region) {
            let login_url = "/account/login/multipass/"
            let region_dict = {
                "CA": "https://ca.switch-bot.com",
                "GB": "https://uk.switch-bot.com",
                "EU": "https://eu.switch-bot.com",
                "JP": "https://www.switchbot.jp",
                "US": "https://us.switch-bot.com",
                "GLOBAL": "https://www.switch-bot.com",
                "TEST": "https://xyz.switch-bot.com",
            }
            let region_url = region_dict[region]
            console.log(region_url + login_url + multipass);
            window.location.href = region_url + login_url + multipass
        },
        "GetThirdPartyToken": function (host, third_id, device_info, code, handle_success, handle_error) {
            let request_url = host + "/account/api/v1/user/third/login"
            let params = {
                "clientId": third_id,
                "issuer": "google",
                "grantType": "code",
                "code": code,
                "deviceInfo": device_info,
                "redirectUri": "https://xyz.switch-bot.com/pages/google-login"
            }
            $.ajax({
                url: request_url,
                type: "POST",
                data: JSON.stringify(params),
                beforeSend: function (request) {
                    request.setRequestHeader("Content-Type", "application/json")
                },
                success: function (data) {
                    handle_success(data)
                },
                error: function (err) {
                    handle_error(err)
                }
            })
        }
    }
})()